import { CHART_VIZ_OPTIONS } from './chartVizTypes';

/** Flat category + count datasets (existing report functions). */
export const DATASET_SHAPE_FLAT = 'flat';

/** parent_key + node_key rows for ECharts hierarchical treemap drill-down. */
export const DATASET_SHAPE_HIERARCHY = 'hierarchy';

const HIERARCHY_MARKERS = ['parent_key', 'node_key'];

/** Viz types allowed for hierarchical drill-down datasets. */
export const HIERARCHY_VIZ_TYPES = new Set(['table', 'treemap']);

/**
 * @param {{ key: string }[]} [columns]
 * @returns {'flat' | 'hierarchy'}
 */
export function detectDatasetShape(columns = []) {
    const keys = new Set(columns.map(c => c.key));
    if (HIERARCHY_MARKERS.every(k => keys.has(k))) return DATASET_SHAPE_HIERARCHY;
    return DATASET_SHAPE_FLAT;
}

/** @param {'flat' | 'hierarchy'} shape */
export function vizOptionsForShape(shape) {
    if (shape === DATASET_SHAPE_HIERARCHY) {
        return CHART_VIZ_OPTIONS.filter(v => HIERARCHY_VIZ_TYPES.has(v.value));
    }
    return CHART_VIZ_OPTIONS;
}

/** @param {{ key: string }[]} [columns] */
export function isHierarchicalDataset(columns) {
    return detectDatasetShape(columns) === DATASET_SHAPE_HIERARCHY;
}

/**
 * Resolve hierarchy column keys from dataset columns and optional encoding override.
 * @param {{ key: string }[]} columns
 * @param {object} [encoding]
 */
export function hierarchyColumnKeys(columns = [], encoding = {}) {
    const keys = new Set(columns.map(c => c.key));
    const pick = (encKey, fallbacks) => {
        if (encoding[encKey] && keys.has(encoding[encKey])) return encoding[encKey];
        return fallbacks.find(k => keys.has(k)) ?? null;
    };
    return {
        parentKey: pick('parent', ['parent_key']),
        idKey: pick('id', ['node_key']),
        labelKey: pick('category', ['label', 'node_key']),
        valueKey: pick('value', ['total_count', 'record_count'])
            ?? columns.find(c => c.type === 'number')?.key,
    };
}
